import PageWithSidebar from "../PageWithSidebar";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import FilterButton from "../Shared/Buttons/FilterButton";
import Escolas from "./Escolas";
import Turmas from "./Turmas";
import Alunos from "./Alunos";
import { useTranslation } from "react-i18next";
import { getLocalizedRoutePath, ROUTE_KEYS } from "../../routes/definitions";

const buildSectionConfig = (routeKeys) => [
  {
    key: "schools",
    component: Escolas,
    routeKey: routeKeys.REGISTRATIONS_HOME,
    labelKey: "registrationsPage.sections.schools.title",
    tabLabelKey: "registrationsPage.sections.schools.tabLabel"
  },
  {
    key: "classes",
    component: Turmas,
    routeKey: routeKeys.REGISTRATIONS_CLASSES,
    labelKey: "registrationsPage.sections.classes.title",
    tabLabelKey: "registrationsPage.sections.classes.tabLabel"
  },
  {
    key: "students",
    component: Alunos,
    routeKey: routeKeys.REGISTRATIONS_STUDENTS,
    labelKey: "registrationsPage.sections.students.title",
    tabLabelKey: "registrationsPage.sections.students.tabLabel"
  }
];

export default function Cadastros({ section }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const sectionConfig = useMemo(() => buildSectionConfig(ROUTE_KEYS), []);
  const activeSection =
    sectionConfig.find(({ key }) => key === section) ?? sectionConfig[0];
  const SectionComponent = activeSection.component;

  useEffect(() => {
    setLoading(true);
    const loadData = async () => {
      await new Promise((r) => setTimeout(r, 500));

      setLoading(false);
    };

    loadData();
  }, []);

  return (
    <PageWithSidebar loading={loading} additionalClasses="flex flex-col text-playmove-darkgray" allowedRoles={['PlaymoveAdmin']}>
      <div className="flex flex-col">
        <div className="flex flex-row h-fit pb-5 border-b-gray-300 border-b-[3px]">
          <div className="flex flex-col">
            <p className="mt-auto text-xl font-dosisbold">{t("registrations")}</p>
            <p className="mb-auto text-2xl font-bold">{t(activeSection.labelKey)}</p>
          </div>
        </div>

        <div className="flex flex-wrap mt-3 justify-center md:justify-start md:flex-row gap-y-4 gap-x-3 mb-auto">
          {sectionConfig.map(({ key, routeKey, tabLabelKey }) => (
            <FilterButton
              key={key}
              text={t(tabLabelKey)}
              selected={activeSection.key === key}
              onClick={() => navigate(getLocalizedRoutePath(routeKey, language))}
            />
          ))}
        </div>
        {SectionComponent && <SectionComponent/>}

      </div>
    </PageWithSidebar>
  );
}
